import { INTEGRATION_API } from "../constants";

/**
 * Sends form data to our custom endpoints for handling form data, where it will
 * then be shipped off to Salesforce. This function replaces the old `hackWebToCase`
 * function.
 *
 * @param {Object} fields an object containing the data from the submitted form
 */

export async function forwardToRegistrationHandler(fields, isSalesforceCase) {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const response = await fetch(
    `${INTEGRATION_API.baseUrl}${
      isSalesforceCase
        ? INTEGRATION_API.endpoints.webToCase
        : INTEGRATION_API.endpoints.standardSalesforce
    }`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(fields)
    }
  );

  return { status: response.ok ? "success" : "failure" };
}
